import {ClientDetails} from "./interface"
import getBundleVersion from "./getBundleVersion"

export default async function apolloClientDetails(): ClientDetails {
  return {
    name: "web",
    version: await getBundleVersion()
  }
}
